module.exports = __webpack_public_path__ + "static/media/icon-add.b5ab4365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/xkCoach/icon-add.svg
// module id = 1659
// module chunks = 0